export const RadioButtonWidgetId = 'RadioButtonWidget';

export enum RadioButtonWidgetAttributes {
  LABEL = 'label',
  VALUE = 'value',
  DISABLED = 'disabled',
}
